import { Form } from 'antd';
import styled from 'styled-components';
import { lightTheme } from '@/styles/themes/light';

const { fonts } = lightTheme;
const FormItem = Form.Item;

export const RadioOptionsContainer = styled.div`
	gap: 8px;
	width: 100%;
	display: flex;
	flex-direction: column;

	.ant-radio-wrapper {
		margin: 0;
		padding: 8px;
		align-items: flex-start;

		&:hover {
			background-color: #f5f5f5;
		}

		.ant-radio {
			margin-top: 2px;
		}
	}
`;

export const FactorDescriptionText = styled.span`
	font-size: ${fonts.label.md.fontSize} !important;
`;

export const FactorDescriptionHeader = styled.span`
	font-size: ${fonts.label.md.fontSize} !important;
	font-weight: ${fonts.label.md.fontWeight} !important;
`;

export const FormItemRow = styled(FormItem)`
	margin: 0;
`;
